const muiTheme = {
  servicePortal: {
    overrides: {
      MuiFilledInput: {
        root: {
          backgroundColor: "rgba(0,0,0,0.04)",
          "&$disabled": {
            backgroundColor: "rgba(0,0,0,0.08)",
          },
        },
      },
      MuiTableRow: {
        root: {
          verticalAlign: "top",
        },
      },
      MuiTypography: {
        h6: {
          fontWeight: '300',
          fontSize: '1.2em'
        },
      },
    },

    palette: {
      type: "light",
      primary: {
        main: "#29a1c5",
        light: "#6ad2f8",
        dark: "#007294",
        middle: "#81AFC7",
      },
      secondary: {
        main: "#F00",
        light: "#e33371",
        dark: "#9a0036",
      },
      error: {
        light: "#e57373",
        main: "#f44336",
        dark: "#d32f2f",
      },
      warning: {
        light: "#ffb74d",
        main: "#ff9800",
        dark: "#f57c00",
      },
      info: {
        light: "#64b5f6",
        main: "#2196f3",
        dark: "#1976d2",
      },
      success: {
        light: "#81c784",
        main: "#4caf50",
        dark: "#388e3c",
      },
      common: {
        lightBlue: "#81AFC7",
      },
    },

    typography: {
      fontFamily: "Roboto",
      subtitle1: {
        fontSize: 16,
        letterSpacing: 0.15,
      },
      subtitle2: {
        fontSize: 19,
        letterSpacing: 0.15,
      },
      body2: {
        fontSize: 14,
        letterSpacing: 0.25,
      },
      button: {
        fontSize: 14,
        letterSpacing: 0.25,
      },
    },
  },
  internalPortal: {
    overrides: {
      MuiFilledInput: {
        root: {
          backgroundColor: "rgba(0,0,0,0.04)",
          "&$disabled": {
            backgroundColor: "rgba(0,0,0,0.08)",
          },
        },
      },
      MuiTableRow: {
        root: {
          verticalAlign: "top",
        },
      },
      MuiTypography: {
        h6: {
          fontWeight: '300',
          fontSize: '1.2em'
        },
      },
    },

    palette: {
      type: "light",
      primary: {
        main: "#1D7CCC",
        light: "#01b2e2",
        dark: "#246AA6",
        middle: "#6F70A9",
        button: "#610eda",
      },
      secondary: {
        main: "#FF7105",
        light: "#ECC74F",
      },
      error: {
        light: "#e57373",
        main: "#f44336",
        dark: "#d32f2f",
      },
      warning: {
        light: "#ffb74d",
        main: "#ff9800",
        dark: "#f57c00",
      },
      info: {
        light: "#64b5f6",
        main: "#2196f3",
        dark: "#1976d2",
      },
      success: {
        light: "#81c784",
        main: "#4caf50",
        dark: "#388e3c",
      },
      common: {
        lightBlue: "#246AA6",
      },
    },

    typography: {
      fontFamily: "Roboto",
      subtitle1: {
        fontSize: 16,
        letterSpacing: 0.15,
      },
      subtitle2: {
        fontSize: 19,
        letterSpacing: 0.15,
      },
      body2: {
        fontSize: 14,
        letterSpacing: 0.25,
      },
      button: {
        fontSize: 14,
        letterSpacing: 0.25,
      },
    },
  },
};

export default muiTheme;
